import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentHelperService {
  environment = environment;

  constructor(private readonly translateService: TranslateService) {}

  isWordpressEnv(): boolean {
    return ['prod', 'deux'].includes(environment.environment);
  }

  wordpressHomeUrl(): string {
    return environment.cmsHost + '/' + this.translateService.currentLang + '/';
  }
}
